// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2BO-C","head":"Table_head__YEO-t","col":"Table_col__3Jpqj"};